import type { Poll2Draft } from "./poll2Helpers";
import { poll2FilledCount } from "./poll2Helpers";

const normalizePoll2Draft = (raw: unknown): Poll2Draft | null => {
  if (!raw || typeof raw !== "object") return null;
  const draft = raw as Poll2Draft;
  return {
    involvement: draft.involvement ?? null,
    relationship: draft.relationship ?? null,
    knowledge: draft.knowledge ?? null,
    comments: draft.comments ?? "",
    evidence: draft.evidence ?? {},
  };
};

export const draftFromAccount = (
  account:
    | {
        poll2_draft?: Poll2Draft | null;
      }
    | null
    | undefined
): Poll2Draft | null => normalizePoll2Draft(account?.poll2_draft);

export const accountHasPoll2Draft = (account: {
  poll2_has_draft?: boolean;
  team_feedback_received?: boolean;
}): boolean =>
  Boolean(account.poll2_has_draft && !account.team_feedback_received);

export const hasPoll2DraftProgress = (draft: Poll2Draft): boolean =>
  poll2FilledCount(draft) > 0 ||
  Boolean(draft.comments.trim()) ||
  Object.values(draft.evidence).some(v => v.trim());
